import * as Yup from "yup";

export const richCard = {
  imageUrl: Yup.string()
    .test(
      "required-imageUrl",
      "La URL del archivo multimedia es requerida para RCS Avanzado",
      function (value) {
        return this.parent.step === 2 ? !!value : true;
      },
    )
    .nullable(),
  cardOrientation: Yup.string()
    .test(
      "required-cardOrientation",
      "La orientación del archivo multimedia es requerida para RCS Avanzado",
      function (value) {
        return this.parent.step === 2 ? !!value : true;
      },
    )
    .nullable(),
  height: Yup.string()
    .test(
      "required-height",
      "La altura del archivo multimedia es requerida para RCS Avanzado",
      function (value) {
        return this.parent.step === 2 ? !!value : true;
      },
    )
    .nullable(),
};

export const actions = {
  buttonActions: Yup.array()
    .of(
      Yup.lazy((value) => {
        const type = value?.type;
        const baseShape = {
          type: Yup.string().required(
            "El tipo de botón de acción es requerido",
          ),
          text: Yup.string()
            .min(
              3,
              "El texto del botón de acción debe tener al menos 3 caracteres",
            )
            .max(
              25,
              "El texto del botón de acción debe tener menos de 25 caracteres",
            )
            .required("El texto del botón de acción es requerido"),
        };
        switch (type) {
          case "openUrlAction":
            return Yup.object().shape({
              ...baseShape,
              action: Yup.string()
                .url("Ingresa una URL válida")
                .required("La URL de la acción es  requerida"),
              application: Yup.string().nullable(),
              webview: Yup.string().nullable(),
              description: Yup.string().nullable(),
            });

          case "openUrlActionShortLink":
            return Yup.object().shape({
              ...baseShape,
              action: Yup.string()
                .url("Ingresa una URL de acción válida")
                .required("La URL de la acción es requerida"),
            });

          case "ViewLocationAction":
            return Yup.object().shape({
              ...baseShape,
              action: Yup.string().nullable(),
              lat: Yup.number()
                .typeError("La latitud de la ubicación debe ser un número")
                .test(
                  "required-lat",
                  "La latitud de la ubicación debe estar en un rango de [-90, 90]",
                  function (value) {
                    return value >= -90 && value <= 90;
                  },
                )
                .required("La latitud de la ubicación es requerida"),
              long: Yup.number()
                .typeError("La longitud de la ubicación debe ser un número")
                .test(
                  "required-long",
                  "La longitud debe estar en un rango de [-180, 180]",
                  function (value) {
                    return value >= -180 && value <= 180;
                  },
                )
                .required("La Longitud de la ubicación es requerida"),
            });
          case "dialAction":
            return Yup.object().shape({
              ...baseShape,
              action: Yup.string()
                .matches(
                  /^(?:\d{10}|[*#]\d{2,5})$/,
                  "Debe ser un número de 10 dígitos o un número corto que empiece con * o #",
                )
                .required("El número de telefono es requerido"),
            });

          case "createCalendarEventAction":
            return Yup.object().shape({
              ...baseShape,
              action: Yup.string().nullable(),
              title: Yup.string()
                .min(3, "Título del evento demasiado corto")
                .max(50, "Título del evento demasiado largo")
                .required("El título del evento es requerido"),
              startTime: Yup.date().required("Inicio requerido para el evento"),
              endTime: Yup.date()
                .min(
                  Yup.ref("startTime"),
                  "La fecha final del evento debe ser posterior",
                )
                .required("Fin requerido"),
              description: Yup.string()
                .min(3, "La descripción del evento es demasiado corta")
                .max(100, "La descripción del evento es demasiado larga")
                .nullable(),
            });

          case "ShareLocationAction":
            return Yup.object().shape({
              ...baseShape,
              action: Yup.string().nullable(),
            });

          default:
            return Yup.object().shape(baseShape);
        }
      }),
    )
    .when("$step", {
      is: (step) => step === 2 || step === 3,
      then: (schema) =>
        schema
          .max(4, "El máximo de acciones es 4, elimina alguna para continuar")
          .test(
            "total-suggestions",
            "La suma de acciones y respuestas no puede ser mayor a 4",
            function (value) {
              const totalActions = value?.length || 0;
              const totalReplies = this.parent.buttonQuickReplies?.length || 0;

              return totalActions + totalReplies <= 4;
            },
          ),

      otherwise: (schema) =>
        schema.max(
          10,
          "El máximo de acciones es 10, elimina alguna para continuar",
        ),
    }),
};

export const replies = {
  buttonQuickReplies: Yup.array()
    .of(
      Yup.object().shape({
        type: Yup.string().required(
          "El tipo de botón de respuesta es requerido",
        ),
        action: Yup.string().required(
          "La acción del botón de respuesta es requerida",
        ),
        text: Yup.string()
          .min(1)
          .max(25, "El texto debe tener menos de 25 caracteres")
          .required("El texto del botón de respuesta es requerido"),
      }),
    )
    .when("$step", {
      is: (step) => step === 2 || step === 3,
      then: (schema) =>
        schema
          .max(
            4,
            "El máximo de respuestas sugerencias es 4, elimina alguna para continuar",
          )
          .test(
            "total-suggestions",
            "La suma de acciones y respuestas no puede ser mayor a 4",
            function (value) {
              const totalReplies = value?.length || 0;
              const totalActions = this.parent.buttonActions?.length || 0;

              return totalActions + totalReplies <= 4;
            },
          ),
      otherwise: (schema) =>
        schema.max(
          11,
          "El máximo de sugerencias es 11, elimina alguna para continuar",
        ),
    }),
};

export const carrousel = {
  carrousel: Yup.array()
    .of(
      Yup.object().shape({
        title: Yup.string()
          .min(3, "El título del carrousel debe tener al menos 3 caracteres")
          .max(
            100,
            "El título del carrousel no puede tener más de 100 caracteres",
          ),
        description: Yup.string()
          .min(
            3,
            "La descripción del carrousel debe tener al menos 3 caracteres",
          )
          .max(
            200,
            "La descripción del carrousel no puede tener más de 100 caracteres",
          ),
        imageUrl: Yup.string()
          .url("Ingresa una URL del carrousel válida")
          .when("$step", {
            is: 3,
            then: (schema) =>
              schema.required(
                "La URL del archivo multimedia del carrousel es requerida",
              ),
            otherwise: (schema) => schema.notRequired(),
          }),
        height: Yup.string().notRequired(),
        ...actions,
        ...replies,
      }),
    )
    .when("$step", {
      is: 3,
      then: (schema) =>
        schema
          .min(2, "Debe haber al menos 2 elementos en el carrusel")
          .max(10, "Máximo 10 elementos"),
      otherwise: (schema) => schema.notRequired(),
    }),
};

const general = {
  campaignName: Yup.string()
    .min(3, "El nombre debe tener al menos 3 caracteres")
    .required("El nombre de la campaña es requerido"),
  uiddatabase: Yup.string().required("La base de datos es requerida"),
  rcsmessage: Yup.string()
    .min(3, "El mensaje debe tener al menos 3 caracteres")
    .max(2000, "El mensaje no puede tener más de 2000 caracteres")
    .test(
      "requited-rcsmessage",
      "El mensaje rcs es requerido",
      function (value) {
        return this.parent.step !== 3 ? !!value : true;
      },
    ),
  dateSend: Yup.string().test(
    "required-dateSend",
    "La fecha es requerida",
    function (value) {
      return this.parent.isScheduled ? !!value : true;
    },
  ),
  fallback: Yup.string()
    .min(3, "El mensaje debe tener al menos 3 caracteres")
    .max(398, "El mensaje no puede tener más de 399 caracteres")
    .required("El mensaje fallback es requerido"),
  proghour: Yup.string().test(
    "required-proghour",
    "La hora es requerida",
    function (value) {
      return this.parent.isScheduled ? !!value : true;
    },
  ),
  title_rcs_message: Yup.string()
    .test(
      "required-title_rcs_message",
      "El título es requerido",
      function (value) {
        return this.parent.step === 2 ? !!value : true;
      },
    )
    .min(3, "El título rcs debe tener al menos 3 caracteres")
    .max(200, "El título rcs no puede tener más de 200 caracteres"),
  ttl: Yup.string().optional(),
};

const test = {
  title_rcs_message: Yup.string()
    .test(
      "required-title_rcs_message",
      "El título es requerido",
      function (value) {
        return this.parent.step === 2 ? !!value : true;
      },
    )
    .min(3, "El título rcs debe tener al menos 3 caracteres")
    .max(200, "El título rcs no puede tener más de 200 caracteres"),
  rcsmessage: Yup.string()
    .min(3, "El mensaje debe tener al menos 3 caracteres")
    .max(2000, "El mensaje no puede tener más de 2000 caracteres")
    .test(
      "requited-rcsmessage",
      "El mensaje rcs es requerido",
      function (value) {
        return this.parent.step !== 3 ? !!value : true;
      },
    ),
  phone: Yup.string()
    .min(10, "El telefono debe tener al menos 10 caracteres")
    .max(10, "El telefono debe tener menos de 10 caracteres")
    .required("El telefono es requerido"),
};

export const testValidationSchema = Yup.object({
  ...test,
  ...richCard,
  ...actions,
  ...replies,
  ...carrousel,
}).test(
  "max-actions-replies",
  "La suma de acciones y respuestas no puede ser mayor a 4 en RichCard o Carrusel",
  function (value) {
    const step = value?.step;

    const actions = value?.buttonActions ?? [];
    const replies = value?.buttonQuickReplies ?? [];

    const total = actions.length + replies.length;

    if (step === 2 || step === 3) {
      if (total > 4) {
        return this.createError({
          path: "buttonActions",
          message: "La suma de acciones y respuestas no puede ser mayor a 4",
        });
      }
    }

    return true;
  },
);
export const validationSchema = Yup.object({
  ...general,
  ...richCard,
  ...actions,
  ...replies,
  ...carrousel,
}).test(
  "max-actions-replies",
  "La suma de acciones y respuestas no puede ser mayor a 4 en RichCard o Carrusel",
  function (value) {
    const step = value?.step;

    const actions = value?.buttonActions ?? [];
    const replies = value?.buttonQuickReplies ?? [];

    const total = actions.length + replies.length;

    if (step === 2 || step === 3) {
      if (total > 4) {
        return this.createError({
          path: "buttonActions",
          message: "La suma de acciones y respuestas no puede ser mayor a 4",
        });
      }
    }

    return true;
  },
);
